export default [
	{ id: 'supplierPerformance1', defaultValue: 0.15 },
	{ id: 'supplierPerformance2', defaultValue: 0.4 },
	{ id: 'supplierPerformance3', defaultValue: 1 },
	{ id: 'supplierBottlePerformance1', defaultValue: 0.3 },
	{ id: 'supplierBottlePerformance2', defaultValue: 0.6 },
	{ id: 'supplierBottlePerformance3', defaultValue: 1 },
	{ id: 'qualityCheckPerformance1', defaultValue: 0.2 },
	{ id: 'qualityCheckPerformance2', defaultValue: 0.45 },
	{ id: 'qualityCheckPerformance3', defaultValue: 0.7 },
	{ id: 'qualityCheckPerformance4', defaultValue: 1 },
	{ id: 'marketingBudgetPerformance_range1_min', defaultValue: 0 },
	{ id: 'marketingBudgetPerformance_range1_max', defaultValue: Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range1_const1', defaultValue: Math.pow( 10, -7 ) },
	{ id: 'marketingBudgetPerformance_range2_min', defaultValue: Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range2_max', defaultValue: 4 * Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range2_const1', defaultValue: 1.33 * Math.pow( 10, -7 ) },
	{ id: 'marketingBudgetPerformance_range2_const2', defaultValue: 0.033 },
	{ id: 'marketingBudgetPerformance_range3_min', defaultValue: 4 * Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range3_max', defaultValue: 6 * Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range3_const1', defaultValue: Math.pow( 10, -7 ) },
	{ id: 'marketingBudgetPerformance_range3_const2', defaultValue: 0.1 },
	{ id: 'marketingBudgetPerformance_range4_min', defaultValue: 6 * Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range4_max', defaultValue: 8 * Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range4_const1', defaultValue: 7.5 * Math.pow( 10, -8 ) },
	{ id: 'marketingBudgetPerformance_range4_const2', defaultValue: 0.25 },
	{ id: 'marketingBudgetPerformance_range5_min', defaultValue: 8 * Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range5_max', defaultValue: 9.8 * Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range5_const1', defaultValue: 8.33 * Math.pow( 10, -8 ) },
	{ id: 'marketingBudgetPerformance_range5_const2', defaultValue: 0.183 },
	{ id: 'marketingBudgetPerformance_range6_min', defaultValue: 9.8 * Math.pow( 10, 6 ) },
	{ id: 'marketingBudgetPerformance_range6_const1', defaultValue: 1 },
	{ id: 'capitalExpenditures_range1_min', defaultValue: 120000000 },
	{ id: 'capitalExpenditures_range1_const1', defaultValue: 80000000 },
	{ id: 'capitalExpenditures_range2_min', defaultValue: 30000000 },
	{ id: 'capitalExpenditures_range2_max', defaultValue: 75000000 },
	{ id: 'capitalExpenditures_range2_const1', defaultValue: 30000000 },
	{ id: 'capitalExpenditures_range3_min', defaultValue: 30000000 },
	{ id: 'capitalExpenditures_range4_const1', defaultValue: 50000000 },
	{ id: 'pricePerformance_range1_min', defaultValue: 0 },
	{ id: 'pricePerformance_range1_max', defaultValue: 1 },
	{ id: 'pricePerformance_range1_const1', defaultValue: -0.6 },
	{ id: 'pricePerformance_range1_const2', defaultValue: 0.8 },
	{ id: 'pricePerformance_range2_min', defaultValue: 1 },
	{ id: 'pricePerformance_range2_max', defaultValue: 2.2 },
	{ id: 'pricePerformance_range2_const1', defaultValue: ( 25 / 49 ) },
	{ id: 'pricePerformance_range2_const2', defaultValue: 2 },
	{ id: 'pricePerformance_range2_const3', defaultValue: ( 50 / 49 ) },
	{ id: 'pricePerformance_range2_const4', defaultValue: ( 25 / 49 ) },
	{ id: 'pricePerformance_range3_min', defaultValue: 2.2 },
	{ id: 'pricePerformance_range3_max', defaultValue: 2.4 },
	{ id: 'pricePerformance_range3_const1', defaultValue: 1 },
	// { id: 'pricePerformance_range3_const2', defaultValue: 2 },
	// { id: 'pricePerformance_range3_const3', defaultValue: ( 50 / 49 ) },
	// { id: 'pricePerformance_range3_const4', defaultValue: ( 25 / 49 ) },
	{ id: 'pricePerformance_range4_min', defaultValue: 2.4 },
	{ id: 'pricePerformance_range4_max', defaultValue: 4 },
	{ id: 'pricePerformance_range4_const1', defaultValue: 58 },
	{ id: 'pricePerformance_range4_const2', defaultValue: 200 },
	{ id: 'pricePerformance_range4_const3', defaultValue: 422 },
	{ id: 'pricePerformance_range5_min', defaultValue: 4 },
	{ id: 'pricePerformance_range5_max', defaultValue: 4.5 },
	{ id: 'pricePerformance_range5_const1', defaultValue: -0.2376 },
	{ id: 'pricePerformance_range5_const2', defaultValue: 1.0692 },
	{ id: 'pricePerformance_range6_min', defaultValue: 4.5 },
	{ id: 'pricePerformance_range6_const1', defaultValue: 0 },
	{ id: 'marketingPerformance_const1', defaultValue: 0.4 },
	{ id: 'marketingPerformance_const2', defaultValue: 0.6 },
	{ id: 'daysReceivablePerformance_range1_max', defaultValue: 20 },
	{ id: 'daysReceivablePerformance_range1_const1', defaultValue: 0 },
	{ id: 'daysReceivablePerformance_range2_min', defaultValue: 20 },
	{ id: 'daysReceivablePerformance_range2_max', defaultValue: 30 },
	{ id: 'daysReceivablePerformance_range2_const1', defaultValue: 0.03 },
	{ id: 'daysReceivablePerformance_range2_const2', defaultValue: 0.6 },
	{ id: 'daysReceivablePerformance_range3_min', defaultValue: 30 },
	{ id: 'daysReceivablePerformance_range3_max', defaultValue: 35 },
	{ id: 'daysReceivablePerformance_range3_const1', defaultValue: 0.04 },
	{ id: 'daysReceivablePerformance_range3_const2', defaultValue: 0.9 },
	{ id: 'daysReceivablePerformance_range4_min', defaultValue: 35 },
	{ id: 'daysReceivablePerformance_range4_max', defaultValue: 45 },
	{ id: 'daysReceivablePerformance_range4_const1', defaultValue: 0.03 },
	{ id: 'daysReceivablePerformance_range4_const2', defaultValue: 0.55 },
	{ id: 'daysReceivablePerformance_range5_min', defaultValue: 45 },
	{ id: 'daysReceivablePerformance_range5_const1', defaultValue: 1 },
	{ id: 'marketingImportance_const1', defaultValue: 1 },
	{ id: 'marketingImportance_const2', defaultValue: 4.5 },
	{ id: 'marketingImportance_const3', defaultValue: 0.1 },
	{ id: 'demandQuota_const1', defaultValue: 0.072135 },
	{ id: 'demandQuota_const2', defaultValue: 1 },
	{ id: 'demandQuota_const3', defaultValue: 0.05 },
	{ id: 'qualityPerformance_const1', defaultValue: 0.65 },
	{ id: 'qualityPerformance_const2', defaultValue: 0.21 },
	{ id: 'qualityPerformance_const3', defaultValue: 0.07 },
	{ id: 'qualityPerformance_const4', defaultValue: 0.04 },
	{ id: 'qualityPerformance_const5', defaultValue: 0.03 },
	{ id: 'qualityPerformance_const6', defaultValue: 0 },
	{ id: 'qualityImportance_const1', defaultValue: 4.5 },
	{ id: 'normalizeSupposedQualityPerformance_const1', defaultValue: 5 },
	{ id: 'shortTermDebtFormula_const1', defaultValue: 1 },
	{ id: 'shortTermDebtFormula_const2', defaultValue: 0.05 },
];
